
import React, { useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import esLocale from 'date-fns/locale/es';

export const Fecha = ({titulo,fecha,setFecha})=>{


    return <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
        <DatePicker
            label={titulo}
            value={fecha}
            inputFormat="dd/MM/yyyy"
            className="max-w-[180px] w-full bg-white"            
            onChange={(newValue) => {
                console.log(newValue)
                setFecha(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
        />
    </LocalizationProvider>
}